import { pick } from 'lodash'

type IdFuncT = (value: unknown) => string

const compositeId =
  (...attrs: string[]): IdFuncT =>
  (entity): string =>
    Object.values(pick(entity, attrs)).join('_')

export default compositeId
